import axios from 'axios';
import {
  ICategoryCollection,
  ICategoryListParams,
  ICreateCategoryPayload,
  IDeleteCategoryPayload,
  IUpdateCategoryPayload,
  ICategoryGoodsCountPayload,
  ICategoryGoodsCountCollection,
  ICategory,
} from 'entities/Category/Category.models';

const basePath = 'category';

export const categoriesTransport = {
  get: (params: ICategoryListParams): Promise<ICategoryCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<ICategory> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateCategoryPayload): Promise<ICategory> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateCategoryPayload): Promise<ICategory> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteCategoryPayload): Promise<ICategory> => axios.delete(`${basePath}`, { data: payload }),
  getGoodsCount: (payload: ICategoryGoodsCountPayload): Promise<ICategoryGoodsCountCollection> =>
    axios.post(`${basePath}/goods-count`, payload),
};
